<template>
  <div class="auto">
    <AutoFights :farmers="farmers" :requestFarmers="this.update"></AutoFights>    
  </div>
</template>

<script>

import store from "@/store";
import Vue from 'vue';
import AutoFights from "@/components/AutoFights.vue";

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
  components: {
    AutoFights
  },
  data() {
    return {
      user: store.getters.getUser,
      farmers: [],
      unsubFarmers: null,
    }
  },
  async mounted() {
    this.getFullFarmers({uid: this.user.uid}).then((res) => {
      this.farmers = res.data.farmers;
    })
  },
  methods: {
    async update() {
      this.getFullFarmers({uid: this.user.uid}).then((res) => {
        this.farmers = res.data.farmers;
      }).catch(() => {
        console.log("An Error Occurred")
        sleep(1000).then(() => {
          this.update();
        })
      });
    },
    getFullFarmers: Vue.firebase.functions.getFullFarmers
  }
}

</script>

<style>
ul li {
  text-align: left;
}

</style>
